module.exports = __webpack_public_path__ + "static/media/Achille-new.c1f5ee01.jpg";